import { render, staticRenderFns } from "./IssuePendingVoucherList.vue?vue&type=template&id=52c2001e"
import script from "./IssuePendingVoucherList.vue?vue&type=script&lang=js"
export * from "./IssuePendingVoucherList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports